/* eslint-disable no-param-reassign */
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { appSyncGraphQLApi } from '../../app/smorgAppSyncGraphQLApi';

export interface RecipesState {
  currentRecipesBoardId: string | null;
  mealBackgroundProcessing: Record<string, boolean>;
  lastUsedCopyRecipesBoardId: string | null;
}

const initialState: RecipesState = {
  currentRecipesBoardId: null,
  mealBackgroundProcessing: {},
  lastUsedCopyRecipesBoardId: null,
};

export const recipesSlice = createSlice({
  name: 'recipes',
  initialState,
  selectors: {
    isMealBackgroundProcessingSelector: createSelector(
      [
        (state: RecipesState) => state.mealBackgroundProcessing,
        (_, mealID) => mealID,
      ],
      (mealBackgroundProcessing, mealID) => mealBackgroundProcessing[mealID],
    ),
  },
  reducers: {
    mealBackgroundProcessing: (state, action: PayloadAction<string[]>) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const mealID of action.payload) {
        state.mealBackgroundProcessing[mealID] = true;
      }
    },
    mealFinishedBackgroundProcessing: (
      state,
      action: PayloadAction<string>,
    ) => {
      const mealID = action.payload;
      delete state.mealBackgroundProcessing[mealID];
    },
    recipesBoardSelected: (state, action: PayloadAction<string>) => {
      state.currentRecipesBoardId = action.payload;
    },
    lastUsedCopyRecipesBoardIdChanged: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.lastUsedCopyRecipesBoardId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(appSyncGraphQLApi.util.resetApiState, (state) => {
      state.currentRecipesBoardId = null;
      state.mealBackgroundProcessing = {};
      state.lastUsedCopyRecipesBoardId = null;
    });
  },
});

export const { isMealBackgroundProcessingSelector } = recipesSlice.selectors;

export const {
  mealBackgroundProcessing,
  mealFinishedBackgroundProcessing,
  recipesBoardSelected,
  lastUsedCopyRecipesBoardIdChanged,
} = recipesSlice.actions;

export default recipesSlice.reducer;
